<template>
  <div
    class="toolbar filters"
  >
    <div class="wrapper">
      <div class="item all">
        <span
          class="field"
          @click="clearCurrentFilter"
        >{{ $t('reports.other.all') }}</span>
      </div>
      <div
        v-for="(value, key) in reports[currentReport].currentFilter"
        :key="key"
        class="item"
      >
        <div
          style="display: flex"
        >
          <UiIcon
            v-if="value.op === '='"
            class="context-icon"
            style="margin-right: 4px;"
            size="10px"
            name="random"
          />
          <UiIcon
            v-if="value.op === '!='"
            class="context-icon"
            style="margin-right: 4px;"
            size="10px"
            name="page-break"
          />

          <span class="field">{{ getDimensionKeyAndTranslate(value) }}:</span>

          <ElDropdown
            trigger="click"
            placement="bottom"
          >
            <span class="value">
              {{ $filters.datetimeFilter(value.row_name[0][value.group], key) }}
              {{ value.row_name.length - 1 ? `[+${value.row_name.length - 1}]` : '' }}
            </span>
            <template v-slot:dropdown>
              <ElDropdownMenu
                :class="{'hidden': !(value.row_name.length - 1)}"
                class="ddgroup drill-item"
              >
                <ElDropdownItem
                  v-for="(row, index) in value.row_name"
                  :key="index"
                >
                  <span class="drill-item--text">{{ $filters.datetimeFilter(row[value.group], key) }}</span>
                  <UiIcon
                    color="var(--text-negative)"
                    name="times"
                    class="close"
                    @click.stop="removeItemCurrentFilter(row, value.row_id[index], key)"
                  />
                </ElDropdownItem>
              </ElDropdownMenu>
            </template>
          </ElDropdown>

          <UiIcon
            color="var(--text-negative)"
            name="times"
            class="close"
            @click="removeCurrentFilter(key)"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'DrilldownFilter',
  props: {
    reports: {
      type: Array,
      required: true,
    },
    currentReport: {
      type: Number,
      required: true,
    },

  },
  emits: ['removeCurrentFilter', 'removeItemCurrentFilter', 'clearCurrentFilter'],

  computed: {
    ...mapGetters('reports', ['reportsSettings']),
  },

  methods: {
    getDimensionKeyAndTranslate(value) {
      const dimensionKey = Object.keys(value.row_name[0])
        .filter(
          (elem) => elem !== 'row_id' && elem !== 'row_filter_column',
        )[0];
      return this.tabsTranslate(dimensionKey);
    },

    tabsTranslate(key) {
      const defaulTitle = this.reportsSettings.dimensions.find((dim) => dim.column_name === key);
      return defaulTitle.title || '';
    },

    clearCurrentFilter() {
      this.$emit('clearCurrentFilter');
    },
    removeItemCurrentFilter(row, value, key) {
      this.$emit('removeItemCurrentFilter', row, value, key);
    },
    removeCurrentFilter(key) {
      this.$emit('removeCurrentFilter', key);
    },

  },
};
</script>
